module.exports = __webpack_public_path__ + "media/images/objednavky-f860710cf072f577390b197c183fe198.png";